import Logo from '~/assets/img/gpaLogo.png'
import { RecoverPassword } from '~/forms/PersonalTrainer/RecoverPassword'
import { RequestRecoverPasswordForm } from '~/forms/PersonalTrainer/RequestRecoverPassword'
import { useQuery } from '~/hooks/useQuery'

export function PersonalTrainerRecoverPassword() {
  const queryParams = useQuery()

  const token = queryParams.get('token')

  return (
    <div className='bg-gpa-blue-50 flex flex-col place-content-center min-h-screen'>
      <div className='flex flex-col justify-center items-center gap-6'>
        <img src={Logo} alt='GPA' width={140} />
        <div className='bg-white p-6 w-full max-w-[500px] rounded-lg shadow-lg'>
          {token ? <RecoverPassword /> : <RequestRecoverPasswordForm />}
        </div>
      </div>
    </div>
  )
}
